import React, {useState, useEffect, useContext} from 'react';
import Header from './components/header/index';
import Body from './components/body/index';
import Footer from './components/footer/index';
import './App.css';
import {GlobalContext} from './utilities/GlobalContext';
import initApp from './utilities/initApp';
import footerData from './config/footer';

function App() {
	let globalContext = useContext(GlobalContext);
	useEffect(() => {
		initApp(globalContext);
	}, []);

	let size = useContext(GlobalContext).size;

	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
			}}
		>
			<Header />
			<Body />
			<Footer mt={true} entries={footerData({globalContextObj: globalContext})} />
		</div>
	);
}

export default App;

function ReactIsInDevelomentMode() {
	return '_self' in React.createElement('div');
}
